import { useEffect , useState } from 'react'
import { useStore } from 'store'
import { hideLoader, showLoader } from 'store/actions/commons'
import iconSecure from 'assets/img/iconPassword.svg'
import styles from '../styles.module.sass'

const ModuleSelected = (props) => {
    const {
        responseTable,
        handleClose,
        event_ID,
        setTypeEvent,
        setTypeMask
    } = props

    const [ , dispatch ] = useStore((state) => state.giftTable.giftTable)
    const [ phoneVal, setPhoneVal ] = useState('')
    const [ flagDisable, setFlagDisable ] = useState(true)
    const [ errorMessage , setErrorMessage ] = useState(null)
    
    const [ nameEvent, setNameEvent ] = useState(null)

    const [ emailGiftTable , setEmailGiftTable ] = useState(null)
    const [ phoneGiftTable , setPhoneGiftTable ] = useState(null)
    const [ textTypeMail, setTextTypeMail ] = useState()
    const [ textTypePhone, setTextTypePhone ] = useState()

    const MaskPhone = (phone) => {
        const newPhone = `** **** ${phone?.substr(-4)}`
        return newPhone
    }
    
    const MaskMail = (mail) => {
        const mascara = '***************************************************************'
        const cuenta = mail?.split('@')[0]
        const correoOculto = `${mascara?.substring(0, (cuenta?.length - 3))}${cuenta?.substr(-3)}`
        const domain = mail?.split('@')[1]
        const newMail = `${correoOculto}@${domain}`
        return newMail
    }

    const handleSubmit = (event) => {
        event.preventDefault()
        let nuEvent 
        if(nameEvent === 'phone'){
            nuEvent = 1
            setTypeMask( textTypePhone )
        }else{
            nuEvent = 2
            setTypeMask( textTypeMail )
        }
        setTypeEvent(nuEvent)
    }

    const handleChange = (event) => {
        const validacion = event
        const actovos = document.querySelectorAll( `.${styles?.cardTypeEvent}.${styles?.active}` )
        
        if( actovos?.length >= 1 ){
            actovos.forEach( element =>
                element.classList.remove(styles?.active)
            )
        }

        document.querySelector(`[data-type="${validacion}"]`).classList.add( styles?.active )

        if(validacion?.length >= 1){
            setFlagDisable(false)
            setNameEvent(validacion)
        }else{
            setFlagDisable(true)
        }
    }

    useEffect(()=>{
        if(responseTable?.customer){
            if(responseTable?.customer?.email){
                const email = String(responseTable?.customer?.email)
                setEmailGiftTable( MaskMail( email ) )
                setTextTypeMail(MaskMail( email ))
            }
            if(responseTable?.customer?.phone_customer){
                const phone = String(responseTable?.customer?.phone_customer)
                setPhoneGiftTable( MaskPhone( phone ) )
                setTextTypePhone(MaskPhone( phone ))
            }
        }
    },[responseTable])


    return(
        <div className={styles?.contModal}>
            <div className={styles?.closeBtn} onClick={handleClose} aria-hidden>X</div>
            <form onSubmit={handleSubmit}>
                <div className={styles?.contIcon}>
                    <img src={iconSecure} alt="icon" className={styles?.iconSecure} />
                </div>
                <h1 className={styles?.titlePhone}>Verificación OTP</h1>
                <p className={styles?.subTitlePhone}>Te enviaremos un código de 6 digitos que necesitarás para acceder a tu Monedero SEARS.</p>
                <h2 className={styles?.subtitle}>Selecciona una opción:</h2>
                <fileset className={styles?.cardTypeEvent} onClick={() => handleChange('email')} data-type="email">
                    <p className={styles?.contTextCard} >Enviar correo electrónico:</p>
                    <p className={styles?.contDataCard} >{ emailGiftTable }</p>

                </fileset>
                <fileset className={styles?.cardTypeEvent} onClick={() => handleChange('phone')} data-type="phone">
                    <p className={styles?.contTextCard} >Enviar SMS </p>
                    <p className={styles?.contDataCard} >Teléfono celular: { phoneGiftTable } </p>

                </fileset>
                {errorMessage
                    ?  <p className={styles?.errorMessageText}>{errorMessage}</p>
                    : null
                }

                <button
                    type="submit"
                    className={`${styles?.buttonSuccess} btn primaryButton`}
                    disabled={flagDisable}
                >Enviar código</button>
            </form>
        </div>
    )
}

export default ModuleSelected